var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWelcomeSeperator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 12,
    viewBox: "0 0 211 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49982 5.75084L74.5998 4.85083C75.2998 4.75083 75.7998 5.35083 75.7998 5.95083C75.7998 6.65083 75.2998 7.15083 74.6998 7.15083C74.6331 7.15083 74.5998 7.15083 74.5998 7.15083L1.49982 6.25084C1.39982 6.25084 1.2998 6.15083 1.2998 5.95083C1.2998 5.85083 1.39982 5.75084 1.49982 5.75084Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5006 5.95079C96.5006 7.65079 95.2006 8.95079 93.6006 8.95079C91.9006 8.95079 90.6006 7.65079 90.6006 5.95079C90.6006 4.35079 91.9006 3.05078 93.6006 3.05078C95.2006 3.05078 96.5006 4.35079 96.5006 5.95079Z",
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4004 5.95C85.4004 6.95 84.6004 7.75 83.7004 7.75C82.7004 7.75 81.9004 6.95 81.9004 5.95C81.9004 5.05 82.7004 4.25 83.7004 4.25C84.6004 4.25 85.4004 5.05 85.4004 5.95Z",
    fill: "#1A1A1A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.6 5.95039C110.6 8.95039 108.2 11.3504 105.3 11.3504C102.3 11.3504 99.9004 8.95039 99.9004 5.95039C99.9004 3.05039 102.3 0.650391 105.3 0.650391C108.2 0.650391 110.6 3.05039 110.6 5.95039Z",
    fill: "#1A1A1A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M209.1 6.2506L135.9 7.15059C135.3 7.15059 134.7 6.65058 134.7 6.05058C134.7 5.35058 135.2 4.85059 135.9 4.85059L209.1 5.7506C209.2 5.7506 209.3 5.85059 209.3 5.95059C209.3 6.15059 209.2 6.2506 209.1 6.2506Z",
    fill: "#1A1A1A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114 5.95079C114 4.35079 115.3 3.05078 117 3.05078C118.6 3.05078 119.9 4.35079 119.9 5.95079C119.9 7.65079 118.6 8.95079 117 8.95079C115.3 8.95079 114 7.65079 114 5.95079Z",
    fill: "#1A1A1A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.1 5.95097C125.1 5.05097 125.9 4.25098 126.9 4.25098C127.9 4.25098 128.7 5.05097 128.7 5.95097C128.7 6.95097 127.9 7.75098 126.9 7.75098C125.9 7.75098 125.1 6.95097 125.1 5.95097Z",
    fill: "#1A1A1A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.95097C0 5.05097 0.799988 4.25098 1.79999 4.25098C2.79999 4.25098 3.60001 5.05097 3.60001 5.95097C3.60001 6.95097 2.79999 7.75098 1.79999 7.75098C0.799988 7.75098 0 6.95097 0 5.95097Z",
    fill: "#1A1A1A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M207.4 5.95097C207.4 5.05097 208.2 4.25098 209.2 4.25098C210.2 4.25098 211 5.05097 211 5.95097C211 6.95097 210.2 7.75098 209.2 7.75098C208.2 7.75098 207.4 6.95097 207.4 5.95097Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeSeperator);
export default __webpack_public_path__ + "static/media/Welcome_seperator.7ecd0de50ca67433e85dfc952b3f3ee0.svg";
export { ForwardRef as ReactComponent };